var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-preview-provider',{attrs:{"module-name":_vm.moduleName},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var brief = ref.brief;
    var step = ref.step;
return [(brief)?_c('activation-brief-products-view',{attrs:{"brief":brief,"step":step,"is-preview":true}}):_c('g-loader',{attrs:{"type":"fixed"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }